import angular, { IOnInit } from "angular";
import {
  IGridSettings,
  vsName as GridSettingsServiceName,
  GridSettingsService,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import { GridConfiguration } from "../../../../records/views/recordGridView";
import { Record } from "../../../../records/server/crud";
const colId = Symbol("main.selectMachine");
export interface ContractSelectEventArgs {
  contract: Record;
}

export interface SelectContractModalConfig {
  gridConfiguration: GridConfiguration;
  defaultQuery?: IQuery;
}

export class SelectContractModalController implements IOnInit {
  static $inject = [GridSettingsServiceName];

  gridSettings: IGridSettings;
  config!: SelectContractModalConfig;
  resolve!: { contractModalConfig: SelectContractModalConfig };
  gridConfiguration!: GridConfiguration;

  constructor(gridSettingService: GridSettingsService) {
    this.setModalWidth("950px");
    this.gridSettings = gridSettingService.getGridSettings(colId);
  }

  $onInit(): void {
    this.config = this.resolve.contractModalConfig;
    this.gridConfiguration = this.config.gridConfiguration;
  }

  private setModalWidth(width: string) {
    const elements = document.querySelector(".modal-content");
    if (!elements) return;
    var modalWindow = angular.element(elements);
    modalWindow.css("width", width);
  }
}
/*
 *   - `close` - A method that can be used to close a modal, passing a result. The result must be passed in this format: `{$value: myResult}`
 *   - `dismiss` - A method that can be used to dismiss a modal, passing a result. The result must be passed in this format: `{$value: myRejectedResult}`
 *   - `modalInstance` - The modal instance. This is the same `$uibModalInstance` injectable found when using `controller`.
 *   - `resolve` - An object of the modal resolve values. See [UI Router resolves] for details.
 *
 */
